import { JSONConfigController } from './json-config.controller';

export const JSONConfigurationComponent: angular.IComponentOptions = {
    // selector: 'projectConfiguration',
    template: require('./json-config.html'),
    bindings: {
        schema: '<',
        configurations: '<',
        fileConfiguration: '<',
        configCategories: '<',
        configFromFile: '<',
        onSetActiveConfig: '&',
        onDeleteConfig: '&',
        activeConfig: '='
    },
    controller: JSONConfigController
}


